import {
  PHYSICIANS_URL,
  LISTING_PAGE,
  BOOKING_PAGE,
  PROFILE_PAGE,
  CONFIRMATION_PAGE,
} from './constants';
import { OasAppContextProps } from '@/types/OasAppContextTypes';

const mapPageInformation = (
  t: (key: string) => string,
  state: Omit<OasAppContextProps, 'breadcrumbs'> & {
    currentBookingInformation?: { doctorUrlTitle: string | null };
  }
): Record<string, { breadcrumb: string; title: string; href: string }> => {
  const doctorUrl =
    state.physicianData?.urlTitle || state?.currentBookingInformation?.doctorUrlTitle || '';
  const doctorName = doctorUrl.replace(/-/g, ' ');

  return {
    root: {
      breadcrumb: t('Common.Home'),
      title: t('Common.Home'),
      href: '/',
    },
    physicians: {
      breadcrumb: t('OAS.LandingPage.Title'),
      title: `${state.hostTitle} ${t('OAS.LandingPage.Title')}`,
      href: PHYSICIANS_URL,
    },
    listing: {
      breadcrumb: t('OAS.Profile.AdditionalBreadcrumb'),
      title: `${state.hostTitle} ${t('OAS.LandingPage.Title')}`,
      href: `${PHYSICIANS_URL}${LISTING_PAGE}`,
    },
    booking: {
      breadcrumb: t('OAS.Profile.Details.BookAppointment'),
      title: t('OAS.Profile.Details.BookAppointment'),
      href: `${PHYSICIANS_URL}${BOOKING_PAGE}/${doctorUrl}`,
    },
    confirmation: {
      breadcrumb: t('OAS.Profile.Details.BookAnAppointment'),
      title: t('OAS.Profile.Details.BookAnAppointment'),
      href: `${PHYSICIANS_URL}${CONFIRMATION_PAGE}`,
    },
    profile: {
      breadcrumb: state.physicianFullName || doctorName || t('OAS.Profile.Details.Title'),
      title: state.physicianFullName || doctorName || 'About',
      href: `${PHYSICIANS_URL}${PROFILE_PAGE}/${doctorUrl}`,
    },
  };
};

export default mapPageInformation;
